import clsx from 'clsx'

export default function Skeleton({ className='' }:{ className?: string }){
  return (
    <div
      className={clsx(
        'relative overflow-hidden rounded-md bg-slate-200/70 dark:bg-slate-800',
        className
      )}
    >
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.2s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent dark:via-white/10" />
      <style>{`@keyframes shimmer{100%{transform:translateX(100%)}}`}</style>
    </div>
  )
}
